import { render, staticRenderFns } from "./paginations.vue?vue&type=template&id=39073f81&scoped=true&"
import script from "./paginations.vue?vue&type=script&lang=js&"
export * from "./paginations.vue?vue&type=script&lang=js&"
import style0 from "./paginations.vue?vue&type=style&index=0&id=39073f81&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39073f81",
  null
  
)

export default component.exports